import React from "react";
import { Label } from "react-bootstrap";
import "./comment.css"

export default ({ comment }) => <Label className="commentLabel"> {comment}</Label >